"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scene = void 0;
class Scene {
    constructor(data) {
        this.id = data.id;
        this.style = data.style;
        this.autoEffect = data.autoEffect;
        this.locationTag = data.locationTag;
        this.sections = data.sections || [];
    }
    getAllOptions() {
        return this.sections.flatMap((_, index) => this.getSectionOptions(index));
    }
    getAvailableOptions(player, gameSession) {
        // This will be implemented in the GameEngine with proper condition evaluation
        return this.getAllOptions();
    }
    getAvailableOptionsBySection(player, gameSession) {
        return this.sections.map((section, sectionIndex) => ({
            sectionIndex,
            options: section.options.filter(option => 
            // This will be implemented in the GameEngine with proper condition evaluation
            true // For now, return all options
            )
        })).filter(sectionData => sectionData.options.length > 0);
    }
    hasAutoEffect() {
        return !!this.autoEffect;
    }
    getAllDescriptions() {
        return this.sections
            .map(section => section.description)
            .filter((desc) => desc !== undefined);
    }
    getFinishOptions() {
        return this.getAllOptions().filter(option => option.target === 'FINISH');
    }
    hasFinishOption() {
        const finishOptions = this.getFinishOptions();
        return finishOptions.length > 0;
    }
    getLeaveOptions() {
        return this.getAllOptions().filter(option => option.target === 'LEAVE');
    }
    hasLeaveOption() {
        const leaveOptions = this.getLeaveOptions();
        return leaveOptions.length > 0;
    }
    findOptionById(optionId) {
        return this.getAllOptions().find(option => option.id === optionId);
    }
    toJSON() {
        return {
            id: this.id,
            style: this.style,
            autoEffect: this.autoEffect,
            locationTag: this.locationTag,
            sections: [...this.sections]
        };
    }
    getSectionOptions(sectionIndex) {
        const section = this.sections[sectionIndex];
        if (!section)
            return [];
        return [
            ...section.options,
            ...this.getInlineOptionsForSection(sectionIndex)
        ];
    }
    getInlineOptionsForSection(sectionIndex) {
        const section = this.sections[sectionIndex];
        if (!section || !section.description || typeof section.description !== 'object') {
            return [];
        }
        return this.extractInlineOptions(section.description.elements);
    }
    getInlineOptions() {
        return this.sections.flatMap((section, index) => this.getInlineOptionsForSection(index));
    }
    extractInlineOptions(elements) {
        const inlineOptions = [];
        for (const element of elements) {
            if (element.type === 'inline-option' && element.optionId && element.target) {
                inlineOptions.push({
                    id: element.optionId,
                    text: this.renderInlineOptionText(Array.isArray(element.content) ? element.content : []),
                    target: element.target,
                    effect: element.effects,
                    ...(element.condition ? { condition: element.condition } : {})
                });
            }
            if (element.type === 'conditional') {
                if (Array.isArray(element.children)) {
                    inlineOptions.push(...this.extractInlineOptions(element.children));
                }
                if (Array.isArray(element.elseChildren)) {
                    inlineOptions.push(...this.extractInlineOptions(element.elseChildren));
                }
            }
            else if (Array.isArray(element.content)) {
                inlineOptions.push(...this.extractInlineOptions(element.content));
            }
        }
        return inlineOptions;
    }
    renderInlineOptionText(content) {
        return content.map((element) => {
            if (element.type === 'text') {
                return element.content;
            }
            else if (element.type === 'bold') {
                return `**${element.content}**`;
            }
            else if (element.type === 'italic') {
                return `*${element.content}*`;
            }
            else if (element.type === 'image') {
                return `[${element.imageType}]`;
            }
            else if (Array.isArray(element.content)) {
                return this.renderInlineOptionText(element.content);
            }
            return '';
        }).join('');
    }
}
exports.Scene = Scene;
//# sourceMappingURL=Scene.js.map